export const environment = {
  production: true,

  notificationApiUrl: "https://cots2-notifications-web.azurewebsites.net/"

};
